export function isDefrentChatListData (oldData, newData) {
    if(oldData.length!==newData.length) return true;
    const oldid = (oldData || []).map(i=> i.id)
    const newid = (newData || []).map(i=>i.id)
    const olduser_reaction_id = (oldData || []).map(i=> i.user_reaction_id)
    const newuser_reaction_id = (newData || []).map(i=>i.user_reaction_id)
    const oldparent_id = (oldData || []).map(i=> i.parent_id)
    const newparent_id = (newData || []).map(i=>i.parent_id)
    const oldtype = (oldData || []).map(i=> i.type)
    const newtype = (newData || []).map(i=>i.type)
    const oldtext = (oldData || []).map(i=> i.text)
    const newtext = (newData || []).map(i=>i.text)
    const oldcreate_at = (oldData || []).map(i=> i.create_at)
    const newcreate_at = (newData || []).map(i=>i.create_at)
    const oldupdated_at = (oldData || []).map(i=> i.updated_at)
    const newupdated_at = (newData || []).map(i=>i.updated_at)
    const olddeleted_at = (oldData || []).map(i=> i.deleted_at)
    const newdeleted_at = (newData || []).map(i=>i.deleted_at)
    const oldrequest_user_account_id = (oldData || []).map(i=> i.request_user_account_id)
    const newrequest_user_account_id = (newData || []).map(i=>i.request_user_account_id)
    const oldresponse_user_account_id = (oldData || []).map(i=> i.response_user_account_id)
    const newresponse_user_account_id = (newData || []).map(i=>i.response_user_account_id)
    const oldself = (oldData || []).map(i=> i.self)
    const newself = (newData || []).map(i=>i.self)
    // console.log(JSON.stringify(newid)!==JSON.stringify(oldid) ||
    // JSON.stringify(olduser_reaction_id)!==JSON.stringify(newuser_reaction_id) ||
    // JSON.stringify(oldparent_id)!==JSON.stringify(newparent_id) ||
    // JSON.stringify(oldtype)!==JSON.stringify(newtype) ||
    // JSON.stringify(oldtext)!==JSON.stringify(newtext) ||
    // JSON.stringify(oldcreate_at)!==JSON.stringify(newcreate_at) ||
    // JSON.stringify(oldupdated_at)!==JSON.stringify(newupdated_at) ||
    // JSON.stringify(olddeleted_at)!==JSON.stringify(newdeleted_at) ||
    // JSON.stringify(oldrequest_user_account_id)!==JSON.stringify(newrequest_user_account_id) ||
    // JSON.stringify(oldresponse_user_account_id)!==JSON.stringify(newresponse_user_account_id) ||
    // JSON.stringify(oldself)!==JSON.stringify(newself));
    
    return JSON.stringify(newid)!==JSON.stringify(oldid) ||
    JSON.stringify(olduser_reaction_id)!==JSON.stringify(newuser_reaction_id) ||
    JSON.stringify(oldparent_id)!==JSON.stringify(newparent_id) ||
    JSON.stringify(oldtype)!==JSON.stringify(newtype) ||
    JSON.stringify(oldtext)!==JSON.stringify(newtext) ||
    JSON.stringify(oldcreate_at)!==JSON.stringify(newcreate_at) ||
    JSON.stringify(oldupdated_at)!==JSON.stringify(newupdated_at) ||
    JSON.stringify(olddeleted_at)!==JSON.stringify(newdeleted_at) ||
    JSON.stringify(oldrequest_user_account_id)!==JSON.stringify(newrequest_user_account_id) ||
    JSON.stringify(oldresponse_user_account_id)!==JSON.stringify(newresponse_user_account_id) ||
    JSON.stringify(oldself)!==JSON.stringify(newself);
}
